// extracted by mini-css-extract-plugin
export var subtitle = "_bx-2";
export var title = "_bx-0";
export var titleNoWrap = "_bx-1";